import * as types from "./actionTypes";

export function updateSelectedCity(selectedCity) {
    return { type: types.UPDATE_SELECTED_CITY, selectedCity };
}